export default function CMultipleVariables() {
  return <h2>C Multiple Variables</h2>;
}
